@if (searchMessage.message) {
  <div class="pb-5">
    <p class="text-sm" [innerHTML]="searchMessage.message | linkify"></p>
    @if (searchMessage.totalCount) {
      <p class="text-sm"><b>{{'searchResult.totalCount'| translate}}:</b> {{searchMessage.totalCount}}</p>
    }
  </div>
}
@if (!searchMessage.message) {
  <p class="pb-5 text-sm" [innerHTML]="'searchResult.info' | translate : {totalResult : searchMessage.totalCount}"></p>
}
@if (searchMessage.searchResultItems && searchMessage.searchResultItems.length>0) {
  <div class="table-container text-sm">
    <p-table [resizableColumns]="true" columnResizeMode="expand"  [value]="searchMessage.searchResultItems">
      <ng-template #header>
        <tr>
          @if (isAvailableDocumentType) {
            <th pResizableColumn>{{ 'searchResult.headers.documentType' | translate }}</th>
          }
          @if (isAvailableDocumentNo) {
            <th pResizableColumn>{{ 'searchResult.headers.documentNumber' | translate }}</th>
          }
          @if (isAvailableType) {
            <th pResizableColumn>{{ 'searchResult.headers.type' | translate }}</th>
          }
          @if (isAvailableName) {
            <th pResizableColumn>{{ 'searchResult.headers.name' | translate }}</th>
          }
          @if (isAvailableTitle) {
            <th pResizableColumn>{{ 'searchResult.headers.title' | translate }}</th>
          }
          @if (isAvailableEmail) {
            <th pResizableColumn>{{ 'searchResult.headers.email' | translate }}</th>
          }
          @if (isAvailablePhone) {
            <th pResizableColumn>{{ 'searchResult.headers.phone' | translate }}</th>
          }
          @if (isAvailableMandant) {
            <th pResizableColumn>{{ 'searchResult.headers.mandant' | translate }}</th>
          }
          @if (isAvailableDescription) {
            <th pResizableColumn>{{ 'searchResult.headers.description' | translate }}</th>
          }
          @if (isAvailableDate) {
            <th pResizableColumn>{{ 'searchResult.headers.date' | translate }}</th>
          }
          @if (isAvailableOrderer) {
            <th pResizableColumn>{{ 'searchResult.headers.orderer' | translate }}</th>
          }
          @if (isAvailableValueNet) {
            <th pResizableColumn class="text-end">{{ 'searchResult.headers.valueNet' | translate }}</th>
          }
          @if (isAvailableDocumentStatus) {
            <th pResizableColumn>{{ 'searchResult.headers.documentStatus' | translate }}</th>
          }
          @if (isAvailableViewPdf) {
            <th pResizableColumn></th>
          }
          @for (col of extraColumns; track col) {
            <th pResizableColumn>{{ col }}</th>
          }
        </tr>
      </ng-template>
      <ng-template #body let-searchItem>
        <tr (click)="!searchItem.readOnly && openDocument(searchItem.documentNo, searchItem.documentType)" [class.hover:bg-gray-100]="!searchItem.readOnly" [class.dark:hover:bg-gray-900]="!searchItem.readOnly" [class.cursor-pointer]="!searchItem.readOnly">
          @if (isAvailableDocumentType) {
            <td>
              <span class="p-column-title">{{ "searchResult.headers.documentType" | translate }}</span>
              <span>{{ getDocumentTypeString(searchItem.documentType) | translate}}</span>
            </td>
          }
          @if (isAvailableDocumentNo) {
            <td>
              <span class="p-column-title">{{ "searchResult.headers.documentNumber" | translate }}</span>
              <span>{{ searchItem.documentNo }}</span>
            </td>
          }
          @if (isAvailableType) {
            <td>
              <span class="p-column-title">{{ "searchResult.headers.type" | translate }}</span>
              <span>{{ searchItem.type }}</span>
            </td>
          }
          @if (isAvailableName) {
            <td>
              <span class="p-column-title">{{ "searchResult.headers.name" | translate }}</span>
              <span>{{ searchItem.name }}</span>
            </td>
          }
          @if (isAvailableTitle) {
            <td>
              <span class="p-column-title">{{ "searchResult.headers.title" | translate }}</span>
              <span>{{ searchItem.title }}</span>
            </td>
          }
          @if (isAvailableEmail) {
            <td>
              <span class="p-column-title">{{ "searchResult.headers.email" | translate }}</span>
              <a [href]="'mailto:' + searchItem.email" (click)="$event.stopPropagation()" class="text-primary underline">{{ searchItem.email }}</a>
            </td>
          }
          @if (isAvailablePhone) {
            <td>
              <span class="p-column-title">{{ "searchResult.headers.phone" | translate }}</span>
              <a [href]="'tel:' + searchItem.phone" (click)="$event.stopPropagation()" class="text-primary underline">{{ searchItem.phone }}</a>
            </td>
          }
          @if (isAvailableMandant) {
            <td>
              <span class="p-column-title">{{ "searchResult.headers.mandant" | translate }}</span>
              <span>{{ searchItem.mandant }}</span>
            </td>
          }
          @if (isAvailableDescription) {
            <td>
              <span class="p-column-title">{{ "searchResult.headers.description" | translate }}</span>
              <span class="truncate hover:text-clip w-full" [title]="searchItem.description">{{ searchItem.description }}</span>
            </td>
          }
          @if (isAvailableDate) {
            <td>
              <span class="p-column-title">{{ "searchResult.headers.date" | translate }}</span>
              <span>{{ isValidDate(searchItem.date) ? (searchItem.date | date: 'dd.MM.yyyy') : '-' }}</span>
            </td>
          }
          @if (isAvailableOrderer) {
            <td>
              <span class="p-column-title">{{ "searchResult.headers.orderer" | translate }}</span>
              <span class="truncate hover:text-clip w-full" [title]="searchItem.orderer">{{ searchItem.orderer }}</span>
            </td>
          }
          @if (isAvailableValueNet) {
            <td class="text-end">
              <span class="p-column-title">{{ "searchResult.headers.valueNet" | translate }}</span>
              <span>{{ searchItem.valueNet | currency:(searchItem.documentCurrency ? searchItem.documentCurrency : 'EUR'):'symbol':'1.2-2':locale() }}</span>
            </td>
          }
          @if (isAvailableDocumentStatus) {
            <td>
              <span class="p-column-title">{{ "searchResult.headers.documentStatus" | translate }}</span>
              <span>{{ (searchItem.documentStatus | statusConverter: searchItem.documentType) | translate }}</span>
            </td>
          }
          @if (isAvailableViewPdf) {

            <td (click)="$event.stopPropagation()">
              <p-button
                type="button"
                [icon]="activePdfItem() === searchItem ? 'pi pi-spin pi-spinner' : 'pi pi-file-pdf'"
                styleClass="icon-with-circle"
                [rounded]="true"
                [outlined]="true"
                size="small"
                [severity]="'secondary'"
                [disabled]="activePdfItem() === searchItem || !searchItem.isPdfArchive || searchItem.readOnly"
                (onClick)="openPdf(searchItem, $event)">
              </p-button>
            </td>
          }
          @for (col of extraColumns; track col) {
            <td>
              <span class="p-column-title">{{ col }}</span>
              <span [innerHtml]="searchItem[col] | linkify"></span>
            </td>
          }
        </tr>
      </ng-template>
    </p-table>
  </div>
}
